
// Components
import CameraBox from "../../../../components/Map/components/LiveCameraPopup/components/CameraBox"
import NoVideoBox from '../NoVideoBox'

const Cameras = ({ url }) => {


    return (
            url
            &&
            (
                Array.isArray(url)
                &&
                <div 
                    style={{
                        display: 'grid',
                        gridTemplateColumns: `repeat(3, 1fr)`,
                        gridTemplateRows: `repeat(3, 1fr)`,
                        gap: '2px',
                        border: '2px solid #222',
                        width: '100%',
                        height: '50vh',
                        minHeight: 480
                    }}
                >
                    {
                        url?.map((data, i) => 
                            <CameraBox key={i} url={data.url} label={data.label} />
                        )
                    }
                </div>
                ||
                <CameraBox controls={true} url={url} />
            )
            ||
            <NoVideoBox />
    )
}

export default Cameras